<div class='card flat mt-none mb-sm'>
  <div>
    <div class='d-flex align-items-center space-between'>
      <span class='name pr-xs'>{{ legalEntity()?.companyName }}</span>
      @if(enableRemove()) {
        <div class='d-flex flex-row justify-end fit-content-min-width actions-wrapper'>
          <button type='button'
                  pButton icon='ui-icon-delete' class='p-button-text middle-icon delete-button'
                  (click)='remove.emit()' data-testid="remove-emit-btn"></button>
        </div>
      }
    </div>

    <div class='pb-xs'>
      <span>{{ legalEntity()?.uniqueIdNumber }}</span>
    </div>
    <div>
      @if (legalEntity()?.country) {
        {{ legalEntity()?.country | countryCodeToLabel }}
      }
    </div>
  </div>
</div>


